import { style, keyframes } from '@vanilla-extract/css';
import { vars } from '@/shared/ui/theme';
import { reducedMotion } from '@/shared/ui/theme';

/**
 * SealStamp — Daily Sealed Log 모티프의 sealing ritual 시각 단위.
 * 평상시 0, 마감 모먼트(0.8s mini Wizard / Stage 2 transient) 표시.
 * Reference: Witcher 3 bestiary entry stamp + Subnautica PDA notification.
 *
 * 한글 친근화 — uppercase·heavy tracking 제거. 라벨은 Pretendard, 숫자/시간은 mono.
 */

const stampScaleIn = keyframes({
  '0%': { transform: 'scale(1.05)', opacity: 0 },
  '100%': { transform: 'scale(1)', opacity: 1 },
});

export const stamp = style({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '0.5rem',
  padding: '0.5rem 0.875rem',
  fontFamily: vars.typography.fontFamily.primary,
  fontSize: '0.8125rem',
  fontWeight: String(600),
  color: vars.bright.primary.light,
  background: 'transparent',
  border: `1px solid ${vars.bright.primary.default}`,
  borderRadius: '6px',
  // cyan glow border (motif spec)
  boxShadow: `0 0 12px ${vars.bright.primary.glow}`,
  whiteSpace: 'nowrap',
  animation: `${stampScaleIn} ${vars.animation.duration.normal} ${vars.animation.easing.easeOut}`,
  '@media': {
    [reducedMotion]: { animation: 'none' },
  },
});

// variant: mini (Wizard 마지막 step 정중앙)
export const stampMini = style({
  fontSize: '0.75rem',
  padding: '0.375rem 0.625rem',
});

// variant: full (TodayMemo aftermath 또는 cinematic display)
export const stampFull = style({
  fontSize: '0.875rem',
  padding: '0.625rem 1rem',
});

// Amber accent dot — Digital Ember motif 미세 차용 (sealing 모먼트 정서).
// 2026-05-07: warningAmber 토큰 차용 → vars.ember.* 토큰으로 정합 (의미 충돌 해소).
export const accentDot = style({
  display: 'inline-block',
  width: '4px',
  height: '4px',
  borderRadius: '50%',
  background: vars.ember.amber.solid,
  boxShadow: `0 0 4px ${vars.ember.amber.bold}`,
});

// Body text inside stamp
export const stampText = style({
  display: 'inline-flex',
  alignItems: 'baseline',
  gap: '0.3em',
});

export const entryNo = style({
  fontFamily: vars.typography.fontFamily.mono,
  fontVariantNumeric: 'tabular-nums',
});

export const label = style({
  color: vars.bright.primary.light,
});

export const separator = style({
  color: vars.typography.textColor.disabled,
  margin: '0 0.15em',
});

export const sealedTime = style({
  fontFamily: vars.typography.fontFamily.mono,
  fontVariantNumeric: 'tabular-nums',
  color: vars.typography.textColor.secondary,
});
